export default __webpack_public_path__ + "static/media/latest-news-img27.7e582806.jpg";